








































































































































































































































































































import VueHtml2pdf from "./VueHtml2pdf.vue";
import ControlsContainer from "./ControlsContainer.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { ShipmentCertificateModel, ShipmentCertificatesApi, WebConfigsApi, WebConfigModel } from "../../apis";
import QrcodeVue from "qrcode.vue";
import moment from "moment";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    VueHtml2pdf,
    ControlsContainer,
    QrcodeVue,
  },
})
export default class Certficate extends Vue {
  @Prop({ default: false }) isExportPdf!: boolean;
  @Prop({ default: true }) hasBackgroundImage!: boolean;
  @Prop({ default: false }) hasStamp!: boolean;
  
  contentRendered = false;
  condition = '';
  progress = 0;
  generatingPdf = false;
  registrationStr = '';
  pdfDownloaded = false;
  controlValue = {
    showLayout: false,
    floatLayout: true,
    enableDownload: true,
    previewModal: true,
    paginateElementsByHeight: 1300,
    manualPagination: true,
    // filename: "Hee Hee",
    pdfQuality: 2,
    pdfFormat: "a4",
    pdfOrientation: "portrait",
    pdfContentWidth: "1000px",
  };
  isShowLogo = false;
  formatTimezone(time){
    let  offset = 0;
    if (this.certificate && this.certificate.location.selectedTimeZone){
        const now = new Date();
        const locationTime = now.toLocaleString("en-US", {timeZone: this.certificate.location.selectedTimeZone});
        const subdate = new Date(locationTime);
        offset = Math.round((subdate.getTime() - now.getTime())/1000);
    }
    return moment(time).add(offset, "second").format("DD MMM YYYY");
  }
  certificate: ShipmentCertificateModel = Object.assign({});
  products = [];
  numberOfPallets = [];
  webConfig: WebConfigModel = null;
  issueDate: string = "";

  addrOfTreatment = "";
  placeOfIssueDate = "";
  formatJoin(arr){
    return !arr
            ? ""
            : this.lodash.join(
            arr.map((val) => val.name),
            "; ");
  }
  mounted(){
    this.$nextTick(() => {
      setTimeout(() => {
        const zoomArea =  document.getElementById('zoom-area');
        const clientHeight = zoomArea.clientHeight;
        if (clientHeight > 700){
          const zoom = 14 * 700 / clientHeight;
          zoomArea.style['font-size'] = zoom.toString() + "px";
        }
      }, 1000);
    });

  }
  async created() {
    this.$util.showLoading();
    try {
      const [rs, configRs] = await Promise.all([
        new ShipmentCertificatesApi().previewShipmentCertificate({ id: this.$route.params.id }),
        new WebConfigsApi().getDefaultWebConfig()
      ]);
      this.certificate = rs.data.data;
      this.isShowLogo = rs.data.data.isPallet;

      this.webConfig = configRs.data.data;
      const conditionNo = this.certificate.conditionNo;
      if (this.isShowLogo){
      switch (conditionNo) {
        case 3:
          this.condition =   this.webConfig.condition3;
          break;
        case 2:
          this.condition =  this.webConfig.condition2;
          break;
      
        default:
           this.condition =  this.webConfig.condition1;
          break;
      }
      } else {
        const requestData = this.certificate.shipmentTreatmentValue[0];
        if(requestData){
          const setPointConditions = [];
          if (requestData.setPoint && requestData.setPoint[0]){
            setPointConditions.push(`${requestData.setPoint[0].value}% O₂`);
          }
          if (requestData.setPoint && requestData.setPoint[1]){
            setPointConditions.push(`${requestData.setPoint[1].value}°C`);
          }
          this.condition = [...setPointConditions, `for at least ${requestData.treatmentTime} ${(requestData.treatmentFormat || '').toLocaleLowerCase()}`].join(", ");

        }
      }

      if (this.certificate && this.certificate.customer){
        switch (this.certificate.registrationNum) {
        case 3:
          this.registrationStr = !!this.certificate.customer.registrationNo3
          ? this.certificate.customer.registrationNo3: this.webConfig.rootRegistrationNo3;
          break;
        case 2:
          this.registrationStr = !!this.certificate.customer.registrationNo2
          ? this.certificate.customer.registrationNo2: this.webConfig.rootRegistrationNo2;
          break;
        default:
          this.registrationStr = !!this.certificate.customer.registrationNo
          ? this.certificate.customer.registrationNo: this.webConfig.rootRegistrationNo1;
          break;
      }
      } else {
        switch (this.certificate.registrationNum) {
        case 3:
          this.registrationStr =  this.webConfig.rootRegistrationNo3;
          break;
        case 2:
          this.registrationStr =  this.webConfig.rootRegistrationNo2;
          break;
        default:
          this.registrationStr =  this.webConfig.rootRegistrationNo1;
          break;
      }
      }
      this.products = this.certificate.requestWeights;
      this.numberOfPallets = this.products.filter(prod => prod.numberOfPallets);
      this.issueDate = this.formatTimezone(this.certificate.desiredIssueDate);
      if (this.certificate.status === 'Accepted') {
        this.issueDate = this.formatTimezone(this.certificate.issueSuggestDate);
      }
      const primaryAddr = this.certificate.customer.fullAddress.find(addr => addr.isPrimary);
      this.addrOfTreatment = primaryAddr ? `${primaryAddr.address}, ${primaryAddr.country}` : "";
      this.placeOfIssueDate = primaryAddr? `${primaryAddr.country}`: "";
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }
  }

  getHref() {
    return window.location.href;
  }

  get showNumberOfPallets() {
    return (!this.lodash.isEmpty(this.numberOfPallets));
  }

  get htmlToPdfOptions() {
    return {
      margin: 0,
      filename: this.certificate.certificateId + " Shipment Certificate",
      image: {
        type: "jpeg",
        quality: 0.98,
      },
      enableLinks: true,
      html2canvas: {
        scale: 3,
        useCORS: true,
        width: 1000,
        height: 1414,
      },
      jsPDF: {
        unit: "in",
        format: this.controlValue.pdfFormat,
        orientation: this.controlValue.pdfOrientation,
      },
    };
  }
  async downloadPdf() {
    if (!(await this.validateControlValue())) return;
    (this.$refs.html2Pdf as any).generatePdf();
  }
  validateControlValue() {
    if (this.controlValue.pdfQuality > 2) {
      alert("pdf-quality value should only be 0 - 2");
      this.controlValue.pdfQuality = 2;
      return false;
    }
    if (!this.controlValue.paginateElementsByHeight) {
      alert("paginate-elements-by-height value cannot be empty");
      this.controlValue.paginateElementsByHeight = 1414;
      return false;
    }
    const paperSizes = [
      "a0",
      "a1",
      "a2",
      "a3",
      "a4",
      "letter",
      "legal",
      "a5",
      "a6",
      "a7",
      "a8",
      "a9",
      "a10",
    ];
    if (!paperSizes.includes(this.controlValue.pdfFormat)) {
      alert(`pdf-format value should only be ${paperSizes}`);
      this.controlValue.pdfFormat = "a4";
      return false;
    }
    if (!this.controlValue.pdfOrientation) {
      alert("pdf-orientation value cannot be empty");
      this.controlValue.pdfOrientation = "portrait";
      return false;
    }
    if (!this.controlValue.pdfContentWidth) {
      alert("pdf-content-width value cannot be empty");
      this.controlValue.pdfContentWidth = "800px";
      return false;
    }
    return true;
  }
  onProgress(progress) {
    this.progress = progress;
    console.log(`PDF generation progress: ${progress}%`);
  }
  startPagination() {
    console.log(`PDF has started pagination`);
  }
  hasPaginated() {
    console.log(`PDF has been paginated`);
  }
  async beforeDownload({ html2pdf, options, pdfContent }) {
    console.log(`On Before PDF Generation`);
    // await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
    // 	const totalPages = pdf.internal.getNumberOfPages()
    // 	for (let i = 1; i <= totalPages; i++) {
    // 		pdf.setPage(i)
    // 		pdf.setFontSize(10)
    // 		pdf.setTextColor(150)
    // 		pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
    // 	}
    // }).save()
  }
  hasDownloaded(blobPdf) {
    console.log(`PDF has downloaded yehey`);
    this.pdfDownloaded = true;
    console.log(blobPdf);
  }
  domRendered() {
    console.log("Dom Has Rendered");
    this.contentRendered = true;
  }
  onBlobGenerate(blob) {
    console.log(blob);
  }
}
